import React, { useState, useEffect, useContext } from "react";
import { connect } from "react-redux";
import { TableContext } from "../../index";
import { stopValidationList } from "../ruleService";
import { showSuccessToast } from "../../validation/ToastContainer";
import { ValidationStatus } from "../../vars";
import { Spinner } from "../../view/Spinner";


function StopValidateButton({ deviceId, validationStatus, setValidationStatus, userCapability }) {
    //Added isClicked  by Octopus DevTeam july 15-2022
    //const [isClicked, setClicked] = useState(false);
    const { config, setConfig } = useContext(TableContext);

    //#region Set User Capabilities
    const [validateButtonCapability, setValidateButtonCapability] = useState(-1);
    useEffect(() => {
        if (userCapability) {
            const validateButtonPermission = userCapability.find(item =>
                item.component === "validatebutton" && item.type === "field")?.permission;
            setValidateButtonCapability(validateButtonPermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    const showSpinner = validationStatus === ValidationStatus.PROCESSING;

    //Added by Octopus Devteam June 17-2022 
    const stopValidateRulesForDevice = (e) => {

        e.preventDefault();

        //get selected devices by id and then get rulePk selected devices
        // eslint-disable-next-line no-unused-vars
        // const ruleIdList = config.selected.length ? config.selected.map(deviceId => {
        //     return config.devices.find(device => device.id === deviceId).rulePk
        // }) : []

        // const validationResultPkList = config.selected //Id of validation result

        return stopValidationList(deviceId)
            .then(() => showSuccessToast('Stopping Validation', 'Stop Validation'))
            .then(() => setValidationStatus(ValidationStatus.DONE))
            .then(() => setConfig({ ...config, lastUpdated: Date.now() }))
    }

    return (
        <div className="row">           
            <div className="col">
                {validationStatus === ValidationStatus.PROCESSING ?
                    <div>
                        <div className={`btn oct_btn-form oct_validate-btn stop-validation ${validateButtonCapability === 0 && 'disabled'}`}
                            onClick={validateButtonCapability <= 0 ? null : stopValidateRulesForDevice}>
                            <span className={`${showSpinner && 'spinner-visible'}`}>Stop Validation</span>
                            {showSpinner && <Spinner />}    
                        </div>
                    </div> : null}
            </div>
        </div>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default connect(mapStateToProps)(StopValidateButton);
